// Tema por variante da tela CRM Dashboard (sunlit / funnel / soft).
// Fonte da verdade: design_handoff_crm_kanban/CRM Dashboard.dc.html + README-dashboard.md.
// Um único objeto V dirige superfícies dos cards, acento, tipografia e rótulos.

import { VARIANT_FONT } from "../../CrmKanban/kanban/tokens";

export const VARIANT_KEY = { sunlit: "a", funnel: "b", soft: "c" };

const THEME = {
  a: {
    key: "a",
    name: "sunlit",
    font: VARIANT_FONT.sunlit,
    pageBg: "#fff",
    cardBg: "#fff",
    cardBorder: "1px solid #F2EADB",
    cardRadius: 14,
    cardShadow: "0 1px 2px rgba(60,50,30,.06)",
    accent: "#F2653A",
    good: "#27AE60",
    bad: "#C0392B",
    warn: "#B7791F",
    money: "#2E7D4F",
    textStrong: "#33302B",
    sublabel: "#8B8577",
    labelMuted: "#A79E8C",
    track: "#F4EFE4",
    selectBg: "#fff",
    selectBorder: "1px solid #E8DFCE",
    selectRadius: 999,
    selectColor: "#6B6456",
    selectWeight: 800,
    kpiLabelColor: "#F2653A",
    kpiUpper: false,
    cardTitleWeight: 900,
    avatarRadius: "50%",
    pillRadius: 999,
    barRadius: 4,
  },
  b: {
    key: "b",
    name: "funnel",
    font: VARIANT_FONT.funnel,
    pageBg: "#fff",
    cardBg: "#fff",
    cardBorder: "1px solid #E9EDF2",
    cardRadius: 12,
    cardShadow: "none",
    accent: "#4A6CF7",
    good: "#1F9D57",
    bad: "#E5484D",
    warn: "#B7791F",
    money: "#1F7A43",
    textStrong: "#151B26",
    sublabel: "#7A8496",
    labelMuted: "#98A2B3",
    track: "#F4F6F9",
    selectBg: "#fff",
    selectBorder: "1px solid #E2E7EE",
    selectRadius: 8,
    selectColor: "#3D4756",
    selectWeight: 600,
    kpiLabelColor: "#98A2B3",
    kpiUpper: true,
    cardTitleWeight: 700,
    avatarRadius: 7,
    pillRadius: 6,
    barRadius: 4,
  },
  c: {
    key: "c",
    name: "soft",
    font: VARIANT_FONT.soft,
    pageBg: "#F7F6FB",
    cardBg: "#fff",
    cardBorder: "1px solid #ECE7F6",
    cardRadius: 16,
    cardShadow: "0 4px 14px rgba(80,60,120,.07)",
    accent: "#7C5CF0",
    good: "#1F9D57",
    bad: "#C0392B",
    warn: "#B7791F",
    money: "#2E7D4F",
    textStrong: "#322A44",
    sublabel: "#8E86A0",
    labelMuted: "#B0A8C2",
    track: "#F0ECF9",
    selectBg: "#fff",
    selectBorder: "1px solid #E3DDF0",
    selectRadius: 10,
    selectColor: "#5A4B6E",
    selectWeight: 700,
    kpiLabelColor: "#7C5CF0",
    kpiUpper: false,
    cardTitleWeight: 800,
    avatarRadius: "50%",
    pillRadius: 999,
    barRadius: 4,
  },
};

export const getTheme = (variant) => THEME[VARIANT_KEY[variant] || "b"];

export default THEME;
